import { useAtomValue } from 'jotai';
import { useAtomCallback } from 'jotai/utils';
import { FilterButtonWithMobileDrawer } from 'components/search/v2/Filter/FilterButtonWithMobileDrawer';
import useMediaQuerySafe from 'hooks/useMediaQuerySafe';
import { getMaxQueryWidth } from 'helpers/breakpoints';
import { CustomFilterButtonProps } from '../FilterButton';
import { selectedExperienceTagAtom, selectedExperienceTagTempAtom } from '../filterStore';
import {
  ExperienceSubTagsContent,
  ExperienceSubTagsLabel,
  isExperienceSubtagActiveAtom,
  isExperienceSubtagHiddenAtom,
} from './ExperienceSubTags';
import { breakpoints } from '../../styleConstants';

export default function ExperienceSubTagsFilterButton(props: CustomFilterButtonProps) {
  const { toggleFilterDropdown, name } = props;
  const isMobile = useMediaQuerySafe(getMaxQueryWidth(breakpoints.QUICK_FILTER_BOTTOM_SHEET_MAX));
  const selectedExperienceTags = useAtomValue(selectedExperienceTagAtom);
  const parentTag = selectedExperienceTags?.[0];
  const title = parentTag ? `${parentTag.charAt(0).toUpperCase()}${parentTag.slice(1)} type` : 'Experience type';

  const clearSubTags = useAtomCallback((_get, set) => {
    set(selectedExperienceTagTempAtom, parentTag ? [parentTag] : []);
  });

  const showResultsClick = useAtomCallback((get, set) => {
    let tempVal = get(selectedExperienceTagTempAtom);
    if (!tempVal.includes(parentTag) && tempVal) {
      tempVal = [parentTag, ...tempVal];
    }
    set(selectedExperienceTagAtom, tempVal ? [...tempVal] : []);
    toggleFilterDropdown(null);
  });

  return (
    <FilterButtonWithMobileDrawer
      {...props}
      title={title}
      label={<ExperienceSubTagsLabel />}
      content={<ExperienceSubTagsContent isDropdown={isMobile} />}
      onClear={clearSubTags}
      onShowResults={showResultsClick}
      isFilterActiveAtom={isExperienceSubtagActiveAtom}
      isFilterHiddenAtom={isExperienceSubtagHiddenAtom}
      name={name}
      toggleDropdown={toggleFilterDropdown}
    />
  );
}
